import React from 'react';

/* ================================
   INTEGRATION & SUPPORT STYLES
================================ */
const integrationStyles = `
.integration-section {
  width: 100%;
  background: #ffffff;
  padding-top: 50px ;
}

.integration-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 40px;
  text-align: center;
}

/* HEADERS */
.integration-title {
  font-size: 38px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.integration-subtitle {
  font-size: 19px;
  font-weight:400;
  color: #64748b;
  margin-bottom: 60px;
}

/* CARD GRID */
.integration-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  margin-bottom: 100px;
}

/* CARD */
.integration-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 24px;
  border: 1px solid #f1f5f9;

  box-shadow:
    0 4px 10px rgba(15, 23, 42, 0.05),
    0 12px 30px rgba(15, 23, 42, 0.08);

  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.integration-card:hover {
  transform: translateY(-6px);
  box-shadow:
    0 10px 25px rgba(15, 23, 42, 0.08),
    0 30px 60px rgba(15, 23, 42, 0.12);
}

/* ICON CIRCLE */
.integration-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 16px;
  border-radius: 12px;
  background: #fff7ed;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #fb923c;
}

.integration-icon i {
  font-size: 34px;
}

/* CARD TEXT */
.integration-card h3 {
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 6px;
}

.integration-card p {
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  line-height: 1.6;
}

/* LIFECYCLE */
.lifecycle-title {
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.lifecycle-subtitle {
  font-size: 18px;
  font-weight: 400;
  color: #64748b;
  margin-bottom: 50px;
}

/* LIFECYCLE ROW */
.lifecycle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 900px;
  margin: 0 auto;
}

/* STEP */
.lifecycle-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.lifecycle-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #fff7ed;

  display: flex;
  align-items: center;
  justify-content: center;
  
  color: #fb923c;
}

.lifecycle-icon i {
  font-size: 24px;
}

.lifecycle-step span {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}
`;

export default function IntegrationSupport() {
  return (
    <>
      {/* INTERNAL CSS */}
      <style>{integrationStyles}</style>

      <section className="integration-section">
        <div className="integration-container">

          {/* HEADER */}
          <h2 className="integration-title">Integration & Field Support</h2>
          <p className="integration-subtitle">
            End-to-end support from installation to commissioning
          </p>

          {/* TOP CARDS */}
          <div className="integration-grid">

            <div className="integration-card">
              <div className="integration-icon">
                <i className="bi bi-tools"></i>
              </div>
              <h3>Installation</h3>
              <p>Professional installation and integration services</p>
            </div>

            <div className="integration-card">
              <div className="integration-icon">
                <i className="bi bi-clipboard-check"></i>
              </div>
              <h3>HATS / SATS</h3>
              <p>Harbour and sea acceptance testing support</p>
            </div>

            <div className="integration-card">
              <div className="integration-icon">
                <i className="bi bi-headset"></i>
              </div>
              <h3>On-site Support</h3>
              <p>Field engineering and commissioning teams</p>
            </div>

            <div className="integration-card">
              <div className="integration-icon">
                <i className="bi bi-graph-up-arrow"></i>
              </div>
              <h3>Commissioning & Upgrades</h3>
              <p>System commissioning and lifecycle upgrades</p>
            </div>

          </div>

          {/* LIFECYCLE */}
          <h3 className="lifecycle-title">Support Lifecycle</h3>
          <p className="lifecycle-subtitle">
            From assessment to long-term mission assurance
          </p>

          <div className="lifecycle-row">

            <div className="lifecycle-step">
              <div className="lifecycle-icon">
                <i className="bi bi-clipboard-data"></i>
              </div>
              <span>Assessment</span>
            </div>

            <div className="lifecycle-step">
              <div className="lifecycle-icon">
                <i className="bi bi-cpu"></i>
              </div>
              <span>Development</span>
            </div>

            <div className="lifecycle-step">
              <div className="lifecycle-icon">
                <i className="bi bi-patch-check"></i>
              </div>
              <span>Integration</span>
            </div>

            <div className="lifecycle-step">
              <div className="lifecycle-icon">
                <i className="bi bi-bug"></i>
              </div>
              <span>Testing</span>
            </div>

            <div className="lifecycle-step">
              <div className="lifecycle-icon">
                <i className="bi bi-shield-lock"></i>
              </div>
              <span>Support</span>
            </div>

          </div>

        </div>
      </section>
    </>
  );
}
